import type { FunctionDirective } from 'vue';

export const focus: FunctionDirective<HTMLElement> = el => {
  el.querySelector('input')?.focus();
};
